export default __webpack_public_path__ + "static/1-121aadd80e2048dc42e435f595e4e24d.jpg";